import i18n from "@/i18n";
import { jump } from "@/lib/auth/service";
export default {
    // 全局错误码
    // <code>: <message> # 仅提示消息
    // <code>: { title, message, action }; # 提示消息并带有后续动作
    10001: () => i18n.t("api.code.unknown_error"),
    10002: () => i18n.t("api.code.method_is_invalid"),
    11001: () => i18n.t("api.code.params_is_invalid"),
    99999: () => i18n.t("api.code.unlogin"),

    10100: () => i18n.t("api.code.login_error"), //登陆失败
    10101: () => i18n.t("api.code.login_expired"), //登陆过期
    10102: {
        message: () => i18n.t("api.code.unlogin"),
        action() {
            if (~location.href.indexOf("login.html")) {
                return false; // 代表不抛出异常提示
            }
            jump("login");
        }
    }, //未登录
    10103: () => i18n.t("api.code.verification_code_error"), //验证码错误
    10104: () => i18n.t("api.code.over_login_error"), //超出登陆错误次数，账号锁10分钟
    10105: () => i18n.t("api.code.token_used"), //token已使用
    10106: () => i18n.t("api.code.invalid_token"), //token无效
    10108: () => i18n.t("api.code.old_password_error"), //旧密码错误
    10109: () => i18n.t("api.code.email_fail_exceeded"), //用户名或邮箱3次验证失败
    10110: () => i18n.t("api.code.email_or_user_error"), //用户名或者邮箱错误
    40030: () => i18n.t("api.code.translate_fail") //翻译失败
};
